import React from 'react'
import { KababContainer } from './kababModal.styled'
function KababModal({ mousePositions = { x: 0, y: 0 }, isOpen, children }) {
  if (!isOpen) return null
  return <KababContainer $positions={mousePositions}>{children}</KababContainer>
}

export default KababModal
